export default {
  PRIMARY: 'primary',
  INFO: 'info',
  DANGER: 'danger',
  SUCCESS: 'success',
  NEW_VEHICLE_AVAILABLE: 'new-vehicle-available',
  SECONDARY: 'secondary',
  WARNING: 'warning',
};
